<template>
  <a-layout-sider breakpoint="lg" class="side-bar" width="225">
    <div class="side-content">
      <div class="logo">LAOT</div>
      <a-menu
        class="menu"
        mode="inline"
        v-model:selectedKeys="selectedKeys"
        v-model:openKeys="openKeys"
        @openChange="onOpenChange"
        v-model:collapsed="collapsed"
      >
        <template v-for="(item, key) in menu">
          <a-sub-menu v-if="item.children?.length > 0" :key="key.toString()">
            <template #title>
              <div class="tip-title">
                <sc-icon class="icon" :type="item.class" v-if="item.class" />
                <span class="text">{{ item.title }}</span>
              </div>
            </template>
            <a-menu-item
              v-for="(subItem, subKey) in item.children"
              :key="key + '_' + subKey"
              @click="router.push(subItem.path!)"
            >
              <div class="title">
                <sc-icon
                  class="icon"
                  :type="subItem.class"
                  v-if="subItem.class"
                />
                {{ subItem.title }}
              </div>
            </a-menu-item>
          </a-sub-menu>
          <a-menu-item
            v-else
            :key="key.toString()"
            @click="router.push(item.path!)"
          >
            <div class="title">
              <sc-icon class="icon" :type="item.class" />
              <span class="text">{{ item.title }}</span>
            </div>
          </a-menu-item>
        </template>
        <a-menu-item key="feedback" @click="openFeedback">
          <div class="title">
            <sc-icon class="icon" type="HighlightOutlined" />
            <span class="text">建议反馈</span>
          </div>
        </a-menu-item>
      </a-menu>
      <a-divider />
      <div class="bottom">
        <a-dropdown>
          <span class="username"
            >{{ user.data.user?.username }} <sc-icon type="DownOutlined"
          /></span>
          <template #overlay>
            <a-menu>
              <a-menu-item>
                <sc-btn
                  text="修改密码"
                  type="link"
                  :handler="() => (showChangePassword = true)"
                />
              </a-menu-item>
              <a-menu-item>
                <sc-btn text="退出登陆" type="link" :handler="logout" />
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </div>
    </div>
    <a-modal
      v-model:visible="showChangePassword"
      title="修改密码"
      @ok="changePassword"
    >
      <div style="margin-bottom: 16px">
        <a-input-password
          v-model:value="changePasswordForm.old"
          placeholder="请输入原密码"
        />
      </div>
      <div style="margin-bottom: 16px">
        <a-input-password
          v-model:value="changePasswordForm.new"
          placeholder="请输入新密码"
        />
      </div>
      <div class="line">
        <a-input-password
          v-model:value="changePasswordForm.confirm"
          placeholder="请确认新密码"
        />
      </div>
    </a-modal>
  </a-layout-sider>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { app, MenuData } from '@/models/App';
import { useRouter } from 'vue-router';
import { user } from '@/models/User';
import { request } from '@/util/request';
import { tokenManager } from '@/util/token';
import { message } from 'ant-design-vue';
import { windows } from '@/components/common/window/Windows';

export default defineComponent({
  name: 'ScSide',
  setup() {
    return { router: useRouter(), user };
  },
  data() {
    return {
      showChangePassword: false,
      menu: app.data.availableMenu,
      selectedKeys: [] as string[],
      collapsed: false,
      openKeys: [] as string[],
      changePasswordForm: {
        old: '',
        new: '',
        confirm: '',
      },
    };
  },
  mounted() {
    const selected = this.check(this.menu, this.router.currentRoute.value.path);
    if (selected) {
      this.openKeys = this.menu.map((_, i) => i.toString());
      this.selectedKeys.push(selected.key);
    }
  },
  methods: {
    onOpenChange(openKeys: string[]) {
      // if (openKeys.length > 0) {
      //   const key = openKeys.pop();
      //   if (key) {
      //     this.openKeys = [key];
      //   }
      // }
    },
    async openFeedback() {
      windows.open({
        content: {
          type: 'route',
          href: '/management/feedback/create',
        },
        title: '提交意见反馈',
      });
    },
    async logout() {
      const res = await request('/management/login/logout', null, {
        noNeedLogin: true,
      });
      if (res) {
        tokenManager.del();
        user.del();
        await this.router.push('/login');
      }
    },
    async changePassword() {
      if (this.changePasswordForm.new != this.changePasswordForm.confirm) {
        message.error('确认密码与新密码不一致');
        return;
      }
      const res = await request(
        '/management/user/changePassword',
        this.changePasswordForm
      );
      if (res) {
        message.success('修改成功');
        this.showChangePassword = false;
      }
    },
    check(
      menu: MenuData,
      target: string,
      indexKey: string[] = []
    ): { key: string; parent: string } | undefined {
      for (const index in menu) {
        const currentIndexKey = indexKey.concat([index]);
        if (menu[index].path === target) {
          return {
            parent: indexKey.join('_'),
            key: currentIndexKey.join('_'),
          };
        }
        const children = menu[index].children;
        if (children) {
          const res = this.check(children, target, currentIndexKey);
          if (res) {
            return res;
          }
        }
      }
    },
  },
  components: {},
});
</script>

<style lang="scss" scoped>
.side-bar {
  border-right: 0;
  background-color: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .side-content {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .logo {
    padding: $spacing-medium 0;
    width: 225px;
    text-align: center;
    color: $color-content-text;
    font-size: $font-size-large;
    font-weight: $font-weight-primary;
    background: #fff;
  }

  .menu {
    flex-grow: 1;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .icon {
    margin-right: $spacing-extra-small;
    font-size: $font-size-large;
  }

  .title {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-weight: $font-weight-primary;
    font-size: $font-size-small;
  }

  .bottom {
    display: flex;
    flex-direction: column;
    align-items: center;

    .username {
      font-size: $font-size-small;
    }

    margin-bottom: $spacing-medium;
  }
}
</style>
